import type { Announcement } from './types';

/**
 * The catalog of one-time in-app announcements. Adding a new announcement is a
 * config change: append an entry here (and add its gating dogfood flag). The
 * generic `AnnouncementPopover` + `useOneTimeAnnouncement` handle rendering and
 * the show-once behavior; no backend change is needed.
 *
 * IMPORTANT: `key` is an immutable, versioned identity. Never reuse a key for
 * different content — bump the suffix (`-v2`) to intentionally re-show. Retired
 * announcements keep their keys claimed, because dismissals are persisted per
 * member by key.
 *
 * The catalog is empty right now, so `OneTimeAnnouncement` renders nothing.
 */
export const availableAnnouncements: readonly Announcement[] = [];

/**
 * Dismissal key of a catalog announcement. This is `string` while the catalog is
 * empty; narrow it to the catalog's own keys (`(typeof availableAnnouncements)[number]['key']`,
 * with the entries declared `as const satisfies readonly Announcement[]`) once there
 * is an entry to derive from.
 */
export type AnnouncementKey = string;

export function getAnnouncement(key: AnnouncementKey): Announcement | undefined {
  return availableAnnouncements.find((announcement) => announcement.key === key);
}
